import { store } from '../../../core/redux/store';
import { LARVA_WS } from '../../../core/datasets/action';

export interface IWebsocketErrorService {
    handleError: (error: unknown) => void;
    handleRemoveError: (event: unknown) => void;
}

class WebsocketErrorService implements IWebsocketErrorService {
    static #instance: WebsocketErrorService | null = null;

    private constructor() {
        return;
    }

    static getInstance(): WebsocketErrorService {
        if (!WebsocketErrorService.#instance) {
            WebsocketErrorService.#instance = new WebsocketErrorService();
        }

        return WebsocketErrorService.#instance;
    }

    handleError(error: unknown): void {
        store.dispatch({
            type: LARVA_WS.WS_CONNECTION_ERROR,
            payload: error,
        });
    }

    handleRemoveError(event: unknown): void {
        if (process.env.NODE_ENV !== 'production') {
            console.warn('Larva websocket connection opened, reason:', { event });
        }
    }
}

export default WebsocketErrorService;
